import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconLibrary } from '../../../../../../shared/icon/icon'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { NodeLibraryEdit } from './node-library-edit'
import { useApiListAssetUnityPackage } from '../../../../../../api-new/state/content'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { NodeLibraryMove } from './node-library-move'
import { NodeLibraryDelete } from './node-library-delete'
import { LoginSysAdmin } from '../../../../../../role/components/login-sys-admin'
import { NodeLibraryEditSys } from './node-library-edit-sys'
import { NodeLibraryCopy } from './node-library-copy'
import { LibraryMenu } from '../../common/menu/node-actions'
import { NodeLibraryAddUnityPackage } from './node-library-add-unity-package'
import { AssetUnityPackage } from '../common/asset-unity-package'
import { PermissionNode } from '../../common/permission/permission-node'
import { useDataContext } from '../data-context'
import { RecordNotFound, notFoundText } from '../../../../../../shared/page/record-view'
import { SECTION } from '../../../../../../shared/navigation/sections'

export const NodeLibraryDetails = ({ parentURL }) => {
  const { url } = useRouteMatch()
  const { nodeID } = useParamsInt()

  const dataContext = useDataContext()

  let library = useMemo(() => dataContext.libraries.find(i => i.id === nodeID), [dataContext.libraries, nodeID])

  const apiListAssetUnityPackage = useApiListAssetUnityPackage()

  const handleMatch = () => apiListAssetUnityPackage.get(`${nodeID}/node`)

  const handleUploadComplete = async (asset, file) => {
    asset.name = file.name
    asset.length = file.size
    await apiListAssetUnityPackage.put(asset.id, asset)
  }

  // Once the area's list has loaded without it, the page says it isn't
  // there (audit F10).
  const missing = dataContext.loaded && !dataContext.error && !library
  const title = useMemo(() => (library ? library.name : missing ? notFoundText('library item') : ''), [library, missing])

  const HeaderMenu = () => <LibraryMenu place="header" url={url} />

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconLibrary} text={title} onMatch={handleMatch}>
        {missing
          ? <RecordNotFound noun="library item" back={{ label: `Go to ${SECTION.assetLibrary.text}`, to: SECTION.assetLibrary.url }} />
          : <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
            {apiListAssetUnityPackage.items.map((asset, i) => <AssetUnityPackage key={i} asset={asset} onUploadComplete={handleUploadComplete} />)}
          </CardFullHeightScrollY>}
      </BreadcrumbView>

      <PermissionNode url={url} nodeID={nodeID} />

      <Route path={`${url}/edit`}>
        <NodeLibraryEdit parentURL={url} nodeID={nodeID} />
      </Route>

      <LoginSysAdmin>
        <Route path={`${url}/edit-sys`}>
          <NodeLibraryEditSys parentURL={url} nodeID={nodeID} />
        </Route>
      </LoginSysAdmin>

      <Route path={`${url}/move`}>
        <NodeLibraryMove parentURL={url} nodeID={nodeID} />
      </Route>

      <Route path={`${url}/copy`}>
        <NodeLibraryCopy parentURL={url} nodeID={nodeID} />
      </Route>

      <LoginSysAdmin>
        <Route path={`${url}/add-unity-package`}>
          <NodeLibraryAddUnityPackage parentURL={url} nodeID={nodeID} />
        </Route>
      </LoginSysAdmin>

      <Route path={`${url}/delete`}>
        <NodeLibraryDelete grandParentURL={parentURL} parentURL={url} nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
